import { createSelector } from "reselect";

const getBillingPaymentMethod = (state) => state.billingPaymentMethod;

export const getSubmittingStripe = (state) => getBillingPaymentMethod(state).submittingStripe;
export const getSubmittingPaymentMethod = (state) => getBillingPaymentMethod(state).submittingPaymentMethod;

export const getPaymentMethodCreditCard = createSelector(
  getBillingPaymentMethod,
  (paymentMethod) => paymentMethod.credit_card
);

export const getPaymentMethodCreditCardType = createSelector(getPaymentMethodCreditCard, (creditCard) =>
  creditCard.get(`type`)
);

export const getIsCreditCardExpired = createSelector(getPaymentMethodCreditCard, (creditCard) => {
  const currentDate = new Date();
  if (creditCard.get(`expiration_year`) > currentDate.getFullYear()) {
    return false;
  } else if (creditCard.get(`expiration_year`) === currentDate.getFullYear()) {
    return creditCard.get(`expiration_month`) < currentDate.getMonth() + 1;
  }
  return true;
});

export const getPaymentMethod = createSelector(getPaymentMethodCreditCard, (creditCard) => ({
  type: creditCard.get(`type`) || `-`,
  cardType: creditCard.get(`card_type`) || `-`,
  cardNumber: creditCard.get(`card_number`) || `-`,
  expirationMonth: creditCard.get(`expiration_month`) || `-`,
  expirationYear: creditCard.get(`expiration_year`) || `-`,
}));

export const getFormattedCreditCardNumber = createSelector(
  (state) => getBillingPaymentMethod(state).credit_card.get(`card_number`),
  (creditCardNumber) => (creditCardNumber ? `●●●● ●●●● ●●●● ${creditCardNumber}` : `-`)
);

export const getBillingAddress = createSelector(
  (state) => getBillingPaymentMethod(state).billing_address,
  (billingAddress) => ({
    name: billingAddress.get(`name`) || ``,
    email: billingAddress.get(`email`) || ``,
    vatId: billingAddress.get(`vat_id`) || ``,
    country: billingAddress.get(`country`) || ``,
    address: billingAddress.get(`address`) || ``,
    city: billingAddress.get(`city`) || ``,
    region: billingAddress.get(`region`) || ``,
    zipCode: billingAddress.get(`zip_code`) || ``,
  })
);

export const isPaymentMethodAvailable = createSelector(
  (state) => getBillingPaymentMethod(state).credit_card,
  (creditCard) => {
    return !!creditCard.get(`type`) && !!creditCard.get(`card_type`);
  }
);

export const isPrePaidPaymentMethod = createSelector(
  (state) => getBillingPaymentMethod(state).credit_card,
  (creditCard) => {
    return creditCard.get(`type`) === "PrePaidPaymentMethod";
  }
);

export const isBillingAddressAvailable = createSelector(
  (state) => getBillingPaymentMethod(state).billing_address,
  (billingAddress) => {
    return !!billingAddress.get(`name`) || !!billingAddress.get(`country`) || !!billingAddress.get(`email`);
  }
);

export const isLegacyPaymentMethod = createSelector(
  (state) => getBillingPaymentMethod(state).credit_card,
  (creditCard) => {
    return creditCard.get(`type`) === "FastSpringPaymentMethod";
  }
);
